import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { verifyLoginOtp } from '../../../redux/actions/auth';


export default function VerifyLoginOTP({options}) {
  const dispatch = useDispatch();
  const {open, setOpen, username, password, ip, browserName} = options;
  const [otp, setOtp] = useState();

  const loginWithOtp = async () => {
    dispatch(verifyLoginOtp({username, password, otp, ip, browserName}))
    // setOpen(false)
  }
  return (
    <Dialog open={open} onClose={() => setOpen(true)} className="relative z-20">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <ExclamationTriangleIcon aria-hidden="true" className="h-6 w-6 text-red-600" />
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full" >
                  <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900">
                    Verify Login OTP
                  </DialogTitle>
                  <div className="mt-2 ">
                        <label className="mb-2 ml-1 font-bold text-xs text-primary">
                          Enter OTP
                        </label>
                        <div className="mb-4 w-full">
                          <input
                            type="text"
                            value={otp}
                            className="focus:shadow-primary-dark text-sm leading-5.6 ease-soft block w-full appearance-none rounded-lg border border-solid border-gray-300 bg-white bg-clip-padding px-3 py-2 font-normal text-primary-dark transition-all focus:border-secondary-dark focus:outline-none focus:transition-shadow"
                            placeholder="Eg: 45893"
                            aria-label="EnterOtp"
                            aria-describedby="email-addon"
                            onChange={(e) => setOtp(e.target.value)}
                          />
                        </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={() => loginWithOtp()}

                className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
              >
                Confirm
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => setOpen(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}